import { Ability } from '@casl/ability';

export type Actions = 'create' | 'read' | 'update' | 'delete';

const ability = new Ability<[Actions, any]>();

export default ability;
